import * as T from "three";

// Source's six sky images use Z-up world axes. Each basis describes the
// direction of the face, image-right and image-top, including the two poles.
export const skyFaces = [
    { suffix: "rt", normal: [1, 0, 0], right: [0, -1, 0], up: [0, 0, 1] },
    { suffix: "lf", normal: [-1, 0, 0], right: [0, 1, 0], up: [0, 0, 1] },
    { suffix: "bk", normal: [0, 1, 0], right: [1, 0, 0], up: [0, 0, 1] },
    { suffix: "ft", normal: [0, -1, 0], right: [-1, 0, 0], up: [0, 0, 1] },
    { suffix: "up", normal: [0, 0, 1], right: [0, -1, 0], up: [-1, 0, 0] },
    { suffix: "dn", normal: [0, 0, -1], right: [0, -1, 0], up: [1, 0, 0] },
];

export function skyGeometry(halfSize = 30000) {
    const geometry = new T.BufferGeometry(), positions = [], uv = [], indices = [];
    skyFaces.forEach(({ normal, right, up }, face) => {
        for (const [s, t] of [[-1, -1], [1, -1], [1, 1], [-1, 1]]) {
            positions.push(...normal.map((n, axis) =>
                halfSize * (n + s * right[axis] + t * up[axis])));
            // VTF/DataTexture row zero is the top of the image (flipY=false).
            uv.push((s + 1) / 2, (1 - t) / 2);
        }
        const vertex = face * 4;
        // Face the camera inside the cube.
        indices.push(vertex, vertex + 1, vertex + 2, vertex, vertex + 2, vertex + 3);
        geometry.addGroup(face * 6, 6, face);
    });
    geometry.setAttribute("position", new T.Float32BufferAttribute(positions, 3));
    geometry.setAttribute("uv", new T.Float32BufferAttribute(uv, 2));
    geometry.setIndex(indices);
    geometry.computeBoundingSphere();
    return geometry;
}
